module.exports = __webpack_public_path__ + "img/katarina_outside_1.9fa839c5.jpg";